import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect, useCallback } from "react";
import { mountComponentByClassWithData } from "../common/mount-helpers";
import Modal from "react-modal";
import closeIcon from "../../images/close-icon.svg";
const ModalSafeForReact18 = Modal;
export const DownloadListingOverView = ({ id, page, fieldsData }) => {
    const [modalIsOpen, setIsOpen] = useState(false);
    const [form, setForm] = useState();
    const [fields, setFields] = useState([]);
    const [rememberme, setRememberMe] = useState(true);
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    useEffect(() => {
        const loadForm = async () => {
            const response = await fetch(window.location.origin + "/wp-json/macleod/v1/form/" + id, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const data = await response.json();
            setForm(data);
        };
        loadForm();
    }, []);
    useEffect(() => {
        if (form) {
            const fields = form.fields.map((field) => {
                const value = fieldsData[field.inputName] || "";
                return {
                    ...field,
                    value,
                };
            });
            const savedGravityFormEntry = localStorage.getItem("gf_form_" + id);
            if (savedGravityFormEntry) {
                const savedFields = JSON.parse(savedGravityFormEntry);
                const newFields = fields.map((field) => {
                    const savedField = savedFields.find((f) => f.id === field.id);
                    if (savedField && field.type !== "hidden") {
                        return {
                            ...field,
                            value: savedField.value,
                        };
                    }
                    return field;
                });
                setFields(newFields);
                return;
            }
            setFields(fields);
        }
    }, [form]);
    useEffect(() => { }, []);
    const rememberMeCheck = () => {
        const rememberInfo = document.querySelector("#consent2");
        if (rememberInfo.checked) {
            localStorage.setItem("gf_form_" + id, JSON.stringify(fields.map((field) => {
                return {
                    id: field.id,
                    value: field.value,
                };
            })));
        }
        else {
            console.log("removing");
            localStorage.removeItem("gf_form_" + id);
        }
    };
    const validateForm = useCallback(async () => {
        rememberMeCheck();
        const errors = {};
        fields.forEach((field) => {
            if (field.isRequired && !field.value) {
                errors[field.id] = field.label + " is required.";
            }
        });
        if (Object.keys(errors).length) {
            setErrors(errors);
            return;
        }
        const consent = document.querySelector("#consent");
        const consentError = document.querySelector("#consentRequired");
        if (!consent.checked) {
            consentError.innerHTML = "This field is required.";
            return;
        }
        else {
            consentError.innerHTML = "";
        }
        const data = {};
        fields.forEach((field) => {
            if (field.inputs) {
                field.inputs.forEach((_, index) => {
                    data["input_" + field.id + "_" + (index + 1)] = field.value;
                });
                return;
            }
            data["input_" + field.id] = field.value;
        });
        try {
            setLoading(true);
            const response = await fetch(window.location.origin + "/wp-json/macleod/v1/form/" + id + "/" + page, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
            const json = await response.json();
            if (json.is_valid) {
                setSuccessMessage(json?.confirmation_message);
                window.location.href = "/thank-you/?r=overview";
            }
        }
        catch (e) {
            setLoading(false);
        }
    }, [loading, fields]);
    const updateField = (id, value) => {
        const updatedFields = fields.map((field) => {
            if (field.id === id) {
                return {
                    ...field,
                    value,
                };
            }
            return field;
        });
        setFields(updatedFields);
    };
    /* Open/Close modal events */
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    return (_jsxs(_Fragment, { children: [_jsx("div", { onClick: openModal, className: "listing-download-link animated-link", children: _jsx("div", { className: "animated-link-border", children: "Request Property Overview" }) }), _jsxs(ModalSafeForReact18, { isOpen: modalIsOpen, onRequestClose: closeModal, contentLabel: "Testing modal", overlayClassName: "modal-overlay", className: "modal-content", children: [_jsx("button", { className: "close-player-trigger", onClick: closeModal, "aria-label": "Close the video player modal", children: _jsx("img", { src: closeIcon, alt: "" }) }), _jsxs("div", { className: "download-overview-form-container", children: [_jsx("h2", { children: form && form.title }), _jsxs("div", { className: "form-info row", children: [form &&
                                        fields.map((field) => (_jsx("div", { className: "col-12 col-md-" + field.layoutGridColumnSpan, children: field.type !== "consent" && (_jsx("div", { className: "form-group form-field", children: field.type === "hidden" ? (_jsx("input", { type: "hidden", id: `field_${field.id}`, value: field.value })) : (_jsxs(_Fragment, { children: [_jsxs("label", { htmlFor: `field_${field.id}`, children: [field.label, " ", field.isRequired && "*"] }), field.type === "textarea" ? (_jsx("textarea", { className: "form-control", id: `field_${field.id}`, placeholder: field.placeholder, value: field.value, onChange: (e) => updateField(field.id, e.target.value) })) : (_jsx("input", { type: field.type, className: "form-control", id: `field_${field.id}`, placeholder: field.placeholder, value: field.value, onChange: (e) => updateField(field.id, e.target.value) })), _jsx("label", { className: "error", children: errors[field.id] || "" })] })) })) }, field.id))), _jsx("div", { className: "col-12", children: _jsxs("div", { className: "form-group", children: [_jsxs("div", { className: "form-check", children: [_jsx("input", { className: "form-check-input", type: "checkbox", id: "consent", required: true }), _jsxs("label", { className: "form-check-label", htmlFor: "consent", children: ["I consent to process my personal information to opt in for email communications, as described in the", " ", _jsx("a", { href: "/privacy-policy/", children: "Privacy Policy" }), ". ", _jsx("strong", { children: "*" })] })] }), _jsx("label", { className: "error", id: "consentRequired" })] }) }), _jsx("div", { className: "col-12", children: _jsx("div", { className: "form-group", children: _jsxs("div", { className: "form-check", children: [_jsx("input", { className: "form-check-input", type: "checkbox", id: "consent2", checked: rememberme, onChange: (e) => {
                                                            setRememberMe(e.target.checked);
                                                            rememberMeCheck();
                                                        } }), _jsx("label", { className: "form-check-label", htmlFor: "consent2", children: "Save my info for next time" })] }) }) })] }), successMessage && (_jsx("div", { className: "success-message", dangerouslySetInnerHTML: { __html: successMessage } })), _jsx("div", { onClick: validateForm, className: "listing-download-link animated-link", children: _jsx("div", { className: "animated-link-border", children: loading ? "Loading..." : "Submit" }) })] })] })] }));
};
document.addEventListener("DOMContentLoaded", () => {
    mountComponentByClassWithData("download-listing-overview", (props) => _jsx(DownloadListingOverView, { ...props }));
});
